import React from 'react';
import { FavoriteButton } from './FavoriteButton';
import { ShareButton } from './ShareButton';
import { AudiCodeButton } from './AudiCodeButton';

export interface NextBestActionsButtonProps {
  vehicleId: string;
  type: 'favorite' | 'share';
}

export const NextBestActionsButton: React.FC<NextBestActionsButtonProps> = ({
  vehicleId,
  type,
}) => {
  if (type === 'favorite') return <FavoriteButton vehicleId={vehicleId} />;
  if (type === 'share') return <ShareButton />;
  if (type === 'audiCode') return <AudiCodeButton />;
  return null;
};
